import(/* webpackMode: "eager", webpackExports: ["IS_SAFARI","IS_IOS","IS_APPLE_WEBKIT"] */ "/root/viholo-web/node_modules/@payloadcms/richtext-lexical/dist/lexical/utils/environment.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/viholo-web/src/app/(frontend)/products/[slug]/page.client.tsx");
